import loadingSlice from '@state/features/loading.slice';
import analyticsMoncler from '@utils/analytics';
import analyticsStone from '@stone/utils/analytics';
import einsteinutils from '@utils/einsteinutils';
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import api from '../../utils/api';
import { ProductActionTypes } from './common.types';
import { addApiError, clearApiErrors } from './errors.slice';
import { addRedirect } from './redirect.slice';
import productSlice from './product.slice';
import { getId } from '@common/utils/brandDiffsUtils';
/**
 * @desc Business logic of effect.
 */
const PRODUCT = 'PRODUCT';
function* handleProductFetch(action) {
    let { pid, sendAnalytics } = action.payload;
    yield* loadFullProduct(pid, sendAnalytics);
}
function* handleProductAndUserFetch(action) {
    let { pid, sendAnalytics } = action.payload;
    yield* loadFullProduct(pid, sendAnalytics, true);
}
function* loadFullProduct(pid, sendAnalytics, askFoUser) {
    try {
        yield put(clearApiErrors());
        yield put(loadingSlice.actions.addLoadingItem(PRODUCT));
        const productData = yield call(api.getProduct, pid);
        if ('redirectOnError' in productData) {
            // The user lands on a  PDP that is not available (depending on his Customer Groups)
            yield put(addRedirect({
                error: productData.error,
                redirectOnError: productData.redirectOnError,
            }));
        }
        else {
            einsteinutils.emptyContext();
            einsteinutils.trackProductDetail(pid, productData === null || productData === void 0 ? void 0 : productData.masterId);
            if (askFoUser) {
                const userShoppingInfo = yield call(api.getUserShoppingInfo);
                yield put(productSlice.actions.updateUserShoppingInfo(userShoppingInfo));
            }
            yield put(productSlice.actions.updateCurrent(productData));
            yield put(loadingSlice.actions.clearLoadingItems());
            switch (sendAnalytics) {
                case 'detail':
                    if (getId() === 'MO') {
                        analyticsMoncler.productDetailViewsWithTransitions(productData);
                    }
                    else {
                        analyticsStone.productDetailPage(productData);
                    }
                    break;
                default:
                    break;
            }
        }
    }
    catch (err) {
        yield put(addApiError({
            code: 'UNKNOWN',
            metadata: { location: 'handleProductFetch' },
        }));
    }
}
function* handleProductSet(action) {
    yield put(productSlice.actions.updateCurrent(action.payload));
    if (action.payload.type === 'tile') {
        yield* loadFullProduct(action.payload.id, 'withTransitions');
    }
}
// if (action.payload.deleteSelection) {
/**
 * @desc Watches every specified action and runs effect method and passes action args to it
 */
function* watchFetchRequest() {
    yield takeEvery(ProductActionTypes.FETCH_PRODUCT, handleProductFetch);
    yield takeEvery(ProductActionTypes.FETCH_PRODUCT_AND_USER, handleProductAndUserFetch);
    yield takeEvery(ProductActionTypes.SET_PRODUCT, handleProductSet);
}
/**
 * @desc saga init, forks in effects, other sagas
 */
export default function* productSaga() {
    yield all([fork(watchFetchRequest)]);
}
